import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ErrorLogComponent = /*#__PURE__*/function (_React$Component) {
  function ErrorLogComponent() {
    var _this;
    _classCallCheck(this, ErrorLogComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ErrorLogComponent, [].concat(args));
    _defineProperty(_this, "state", {
      hasError: false
    });
    return _this;
  }
  _inherits(ErrorLogComponent, _React$Component);
  return _createClass(ErrorLogComponent, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _this$props = this.props,
        logger = _this$props.logger,
        level = _this$props.level,
        onError = _this$props.onError;
      logger[level](error, {
        message: error.message,
        reactInfo: errorInfo.componentStack
      });
      this.setState({
        hasError: true
      });
      if (onError) {
        onError(error, errorInfo);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        if (this.props.errorStub) {
          return this.props.errorStub;
        } else {
          return /*#__PURE__*/_jsx("span", {});
        }
      }
      return this.props.children;
    }
  }, {
    key: "tryRender",
    value: function tryRender() {
      this.setState({
        hasError: false
      });
    }
  }]);
}(React.Component);
_defineProperty(ErrorLogComponent, "defaultProps", {
  level: 'error'
});